import { render, staticRenderFns } from "./DesgloseLibroDetalle.vue?vue&type=template&id=30ae6062&scoped=true"
import script from "./DesgloseLibroDetalle.vue?vue&type=script&lang=js"
export * from "./DesgloseLibroDetalle.vue?vue&type=script&lang=js"
import style0 from "./DesgloseLibroDetalle.vue?vue&type=style&index=0&id=30ae6062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ae6062",
  null
  
)

export default component.exports